import React, { useEffect } from 'react';
import { useInvoicePdf } from '../../hook';
import { IInvoicePDF } from '../../type';
import PdfPreview from '../PdfPreview';
import Loading from '@common/components/Loading';

export const ViewPdf: React.FC<IInvoicePDF> = (attrs) => {
  const { isCanvas, pdfContent, getInvoicePdfUrl, invoicePdfUrl } =
    useInvoicePdf(attrs);

  useEffect(() => {
    if (!isCanvas) {
      if (!attrs.initializeList) {
        getInvoicePdfUrl();
      }
    }
  }, [attrs.initializeList, getInvoicePdfUrl]);

  if (isCanvas) {
    return (
      <div
        style={{
          width: attrs.width,
          height: attrs.height,
          overflow: 'auto',
        }}
      >
        <PdfPreview content={pdfContent} />
      </div>
    );
  }
  if (!invoicePdfUrl) {
    return (
      <div>
        <Loading />
      </div>
    );
  }
  return (
    <div
      style={{
        width: attrs.width,
        height: attrs.height,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={invoicePdfUrl}
        style={{
          width: '100%',
          height: '100%',
        }}
        id={`invoice-pdf-${attrs.id}`}
      />
    </div>
  );
};
